// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const swatch = {
    black: "#000000",
    white: "#ffffff",
    grey: {
        pale: "#F8F8F8",
        lighter: "#F3F5F7",
        light: "#DBE0E6",
        main: "#9CA5B2",
        dark: "#505D67",
    },
    secondary: "#2F6E1C",
};

const colors: Styleguide["colors"] = {
    primary: {
        main: "#1E3059",
        contrast: swatch.white,
        light: "#0D2C6B",
        lighter: "#9FABC4",
    },
    secondary: {
        main: swatch.secondary,
        contrast: swatch.white,
        light: "#61BC46",
        dark: "#114900",
    },
    tertiary: {
        main: "#36404C",
        contrast: "#FFFFFF",
    },
    common: {
        background: swatch.white,
        backgroundContrast: swatch.grey.dark,
        accent: swatch.grey.pale,
        accentContrast: swatch.grey.dark,
        border: swatch.grey.light,
        disabled: swatch.grey.light,
        borderDark: swatch.grey.main,
        borderLight: swatch.grey.lighter,
        disabledLight: swatch.grey.pale,
    },
    text: {
        main: swatch.grey.dark,
        disabled: swatch.grey.dark,
        accent: "#1E3059",
        link: "#2F6E1C",
        linkHover: swatch.secondary,
        disabledLight: swatch.grey.main,
        hint: "#666666",
    },
    success: {
        main: "#0f7b5c", // Alerts/Contrast -> Success
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Success" token
        light: "#e4f5f4", // Alerts/Light -> Success
    },
    warning: {
        main: "#a45e28", // Alerts/Contrast -> Warning
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Warning" token
        light: "#fff5e9", // Alerts/Light -> Warning
    },
    danger: {
        main: "#cb2045", // Alerts/Contrast -> Error
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Error" token
        light: "#f5e8ea", // Alerts/Light -> Error
    },
    info: {
        main: "#1676b1", // Alerts/Contrast -> Info
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Info" token
        light: "#f0faff", // Alerts/Light -> Info
    },
    icon: {
        main: "#9DABCF",
        disabled: swatch.grey.main,
    },
};

export default colors;
